import React from 'react';
import { gql } from '@apollo/client';
import { Show, SimpleShowLayout, TextField } from 'react-admin';
import TimestampFields from 'components/TimestampFields';

const ProfessionalPositionsShow = () => (
  <Show>
    <SimpleShowLayout>
      <TextField label="ID" source="id" />
      <TextField label="Professional ID" source="professional_id" />
      <TextField label="Position" source="position.display_name" />
      <TimestampFields />
    </SimpleShowLayout>
  </Show>
);

ProfessionalPositionsShow.query = gql`
  query GET_ONE($id: Int!) {
    professionalPosition(id: $id) {
      id
      position_id
      professional_id
      position {
        id
        display_name
      }
      created_at
      updated_at
    }
  }
`;

export default ProfessionalPositionsShow;
